const IconTicket = ({ width = 33, height = 32, fill = "#252525" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7196 7.28159V10.0041M18.7196 22.4801V24.7571M18.7196 18.6152V13.1916M24.5426 25C26.729 25 28.5 23.3604 28.5 21.336V18.4195C27.0532 18.4195 25.888 17.3407 25.888 16.0012C25.888 14.6616 27.0532 13.5817 28.5 13.5817L28.4987 10.664C28.4987 8.63963 26.7265 7 24.5413 7H8.4587C6.27347 7 4.50125 8.63963 4.50125 10.664L4.5 13.6767C5.94681 13.6767 7.11202 14.6616 7.11202 16.0012C7.11202 17.3407 5.94681 18.4195 4.5 18.4195V21.336C4.5 23.3604 6.27096 25 8.45745 25H24.5426Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7196 7.28159V10.0041M18.7196 22.4801V24.7571M18.7196 18.6152V13.1916M24.5426 25C26.729 25 28.5 23.3604 28.5 21.336V18.4195C27.0532 18.4195 25.888 17.3407 25.888 16.0012C25.888 14.6616 27.0532 13.5817 28.5 13.5817L28.4987 10.664C28.4987 8.63963 26.7265 7 24.5413 7H8.4587C6.27347 7 4.50125 8.63963 4.50125 10.664L4.5 13.6767C5.94681 13.6767 7.11202 14.6616 7.11202 16.0012C7.11202 17.3407 5.94681 18.4195 4.5 18.4195V21.336C4.5 23.3604 6.27096 25 8.45745 25H24.5426Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7196 7.28159V10.0041M18.7196 22.4801V24.7571M18.7196 18.6152V13.1916M24.5426 25C26.729 25 28.5 23.3604 28.5 21.336V18.4195C27.0532 18.4195 25.888 17.3407 25.888 16.0012C25.888 14.6616 27.0532 13.5817 28.5 13.5817L28.4987 10.664C28.4987 8.63963 26.7265 7 24.5413 7H8.4587C6.27347 7 4.50125 8.63963 4.50125 10.664L4.5 13.6767C5.94681 13.6767 7.11202 14.6616 7.11202 16.0012C7.11202 17.3407 5.94681 18.4195 4.5 18.4195V21.336C4.5 23.3604 6.27096 25 8.45745 25H24.5426Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7196 7.28159V10.0041M18.7196 22.4801V24.7571M18.7196 18.6152V13.1916M24.5426 25C26.729 25 28.5 23.3604 28.5 21.336V18.4195C27.0532 18.4195 25.888 17.3407 25.888 16.0012C25.888 14.6616 27.0532 13.5817 28.5 13.5817L28.4987 10.664C28.4987 8.63963 26.7265 7 24.5413 7H8.4587C6.27347 7 4.50125 8.63963 4.50125 10.664L4.5 13.6767C5.94681 13.6767 7.11202 14.6616 7.11202 16.0012C7.11202 17.3407 5.94681 18.4195 4.5 18.4195V21.336C4.5 23.3604 6.27096 25 8.45745 25H24.5426Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7196 7.28159V10.0041M18.7196 22.4801V24.7571M18.7196 18.6152V13.1916M24.5426 25C26.729 25 28.5 23.3604 28.5 21.336V18.4195C27.0532 18.4195 25.888 17.3407 25.888 16.0012C25.888 14.6616 27.0532 13.5817 28.5 13.5817L28.4987 10.664C28.4987 8.63963 26.7265 7 24.5413 7H8.4587C6.27347 7 4.50125 8.63963 4.50125 10.664L4.5 13.6767C5.94681 13.6767 7.11202 14.6616 7.11202 16.0012C7.11202 17.3407 5.94681 18.4195 4.5 18.4195V21.336C4.5 23.3604 6.27096 25 8.45745 25H24.5426Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconTicket;
